const pages = [
  {
    directory: "root",
    url: "",
    private: false,
    index: true,
  },
  {
    directory: "registration",
    url: "registration",
    private: false,
    index: false,
  },
  {
    directory: "dashboard",
    url: "dashboard",
    private: true,
    index: false,
    children: [
      {
        directory: "ahkam",
        url: "ahkam",
        key: "ahkam",
        priority: 0,
      },
    ],
  },
];

export default pages;
